// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/style.css
// module id = 547
// module chunks = 4